
import React, { useState } from "react";
import ProductForm from "../Forms/ProductForm";
import { AddProductsApi } from "../../ApiCalls/AddProducts";
import SuccessPoP from "../SuccessFullPopUp/SuccessPoP";

const AddProducts = ({ refetchProducts }) => {
   const [productData, setProductData] = useState({
      name: "",
      product_code: "",
      description: "",
      actual_price: "",
      category: "",
      subcategory: "",
      stock: "",
      offer_percent: "",
      min_order_quantity: "",
      min_order_quantity_two: "",
      min_order_quantity_three: "",
      min_order_quantity_four: "",
      min_order_quantity_five: "",
      delivery_charge: "",
      vendor: "",
      brand: "",
      currency: "",
      unit: "",
      product_images: [],
    });

  // const [popup, setPopup] = useState({
  //   visible: false,
  //   success: false,
  //   button: false,
  //   message: "",
  //   subMessage: "",
  // });
  const [popup, setPopup] = useState({
      visible: false,
      success: false,
      button: false,
      message: "",
      subMessage: "",
      showCloseIcon: false,
      Trybutton: false,
    });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // const handleImageChange = (e) => {
  //   const files = Array.from(e.target.files);
  //   setProductData((prevData) => ({
  //     ...prevData,
  //     product_images: [...prevData.product_images, ...files],
  //   }));
  // };
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setProductData((prevData) => ({
      ...prevData,
      product_images: [...prevData.product_images, ...files],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(productData).forEach((key) => {
      if (key !== "product_images" && key !== "brand_logo") {
        formData.append(key, productData[key]);
      }
    });

    if (productData.brand_logo) {
      formData.append("brand_logo", productData.brand_logo);
    }

    productData.product_images.forEach((image) => {
      formData.append("images", image);
    });
// const data = {
//   "name": "Red Clay Bricks",
//   "product_code": "RBM-CLAY-001",
//   "description": "High-quality red clay bricks ideal for construction. Durable, weather-resistant, and environmentally friendly.",
//   "actual_price": "8",
//   "category": "17",
//   "subcategory": "29",
//   "stock": "50000",
//   "offer_percent": "5",
//   "min_order_quantity": "500",
//   "min_order_quantity_two": "1000",
//   "min_order_quantity_three": "2500",
//   "min_order_quantity_four": "5000",
//   "min_order_quantity_five": "10000",
//   "delivery_charge": "1200",
//   "brand": "27",
//   "product_images": [
    
//   ]
// }
    try {
      await AddProductsApi(formData);
      setPopup({
        visible: true,
        success: true,
        button: false,
        showCloseIcon: true,
        message: "Product Added Successfully!",
        subMessage: "Your product has been added to the catalog.",
      });

      setProductData({
        name: "",
        description: "",
        actual_price: "",
        category: "",
        subcategory: "",
        stock: "",
        offer_percent: "",
        min_order_quantity: "",
        min_order_quantity_two: "",
        min_order_quantity_three: "",
        min_order_quantity_four: "",
        min_order_quantity_five: "",
        delivery_charge: "",
        brand: "",
        product_code: "",
        vendor: "",
        currency: "",
        unit: "",
        product_images: [],
      });

      if (refetchProducts) await refetchProducts();
    } catch (error) {
      console.error("Error adding product:", error);
      setPopup({
        visible: true,
        success: false,
        button: false,
        showCloseIcon: true,
        message: "Error Adding Product!",
        subMessage: "There was an issue adding your product. Please try again.",
      });
    }
  };
  const handleRemoveImage = (index) => {
    setProductData((prevData) => ({
      ...prevData,
      product_images: prevData.product_images.filter((_, i) => i !== index),
    }));
  };

  return (
    <div className="h-full w-full p-2 ">
      <h1 className="text-2xl font-bold text-center mb-4 text-green-600">Add Product</h1>
      <ProductForm
        productData={productData}
        handleChange={handleChange}
        handleImageChange={handleImageChange}
        handleSubmit={handleSubmit}
        handleRemoveImage={ handleRemoveImage}
      />
      {popup.visible && (
        <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform  bg-white shadow-md w-fit h-fit rounded-lg ">
        {/* // <div className="fixed inset-0 flex items-center w-full h-full justify-center  bg-black bg-opacity-50"> */}
          <SuccessPoP
            message={popup.message}
            status ={popup.success}
            button= {popup.button}
            subMessage={popup.subMessage}
            showCloseIcon={popup.showCloseIcon}
            onClose={() => setPopup({ visible: false, success: false })}
            // redirectPath="/" 
          />
        </div>
      )}
    </div>
  );
};

export default AddProducts;
